import classNames from "classnames"
import React from "react"

import {
  getThemeColor,
  getIconFillClass,
  getCheckmarkStrokeColor,
  getDashStrokeColor,
} from "./utils"
import { isTablet } from "../../../../utils/V2/screen"
import CircleCheckIcon from "../../../elements/V2/Icons/CircleCheckIcon"
import CircleCrossIcon from "../../../elements/V2/Icons/CircleCrossIcon"
import Typography from "../../../elements/V2/Typography"

import CircleDashIcon from "@components/elements/V2/Icons/CircleDashIcon"

type Matches = {
  isCrossIcon?: RegExpMatchArray | null
  isCheckIcon?: RegExpMatchArray | null
  isCheckIconBlackStroke?: RegExpMatchArray | null
  isDashIcon?: RegExpMatchArray | null
}

type IconCellProps = {
  matches: Matches
  theme: "light" | "dark"
}

const IconCell = ({ matches, theme }: IconCellProps) => {
  let icon: React.ReactNode = null
  let text: string | undefined

  if (matches.isCrossIcon) {
    text = matches.isCrossIcon[1]
    icon = (
      <CircleCrossIcon
        className={classNames(
          "shrink-0",
          theme === "light" ? "stroke-charcoal" : "stroke-white"
        )}
      />
    )
  } else if (matches.isCheckIcon) {
    const color = matches.isCheckIcon[1]
    text = matches.isCheckIcon[2]
    icon = (
      <CircleCheckIcon
        width={29}
        height={29}
        showBorder={false}
        opacity={1}
        className={classNames("shrink-0", getIconFillClass(color))}
        checkmarkClassName={getCheckmarkStrokeColor(color)}
      />
    )
  } else if (matches.isCheckIconBlackStroke) {
    const color = matches.isCheckIconBlackStroke[1]
    text = matches.isCheckIconBlackStroke[2]
    icon = (
      <CircleCheckIcon
        width={29}
        height={29}
        showBorder={false}
        opacity={1}
        className={classNames("shrink-0", getIconFillClass(color))}
        checkmarkClassName={color === "white" ? "stroke-black" : "stroke-white"}
      />
    )
  } else if (matches.isDashIcon) {
    const color = matches.isDashIcon[1]
    text = matches.isDashIcon[2]
    icon = (
      <CircleDashIcon
        width={29}
        height={29}
        showBorder={false}
        opacity={1}
        className={classNames("shrink-0", getIconFillClass(color))}
        dashClassName={getDashStrokeColor(color)}
      />
    )
  }

  if (!icon) return null

  return (
    <div
      className={classNames(
        "flex items-center gap-8 sm:gap-32",
        text && "w-full justify-start"
      )}
    >
      {icon}
      {text && (
        <Typography
          font="grotesk"
          weight="book"
          color={getThemeColor(theme)}
          size={isTablet() ? "subscript-sm" : "body-md"}
          text={text}
          className="pb-[1px]"
        />
      )}
    </div>
  )
}

export default IconCell
